import React from "react";
import { NavLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ContactMailIcon from "@material-ui/icons/ContactMail";
import classes from "./SideDrawer.module.css";
import MediBiro_png from "../../assets/Images/logo.png";
import * as actionTypes from "../../store/actions";
import { Button } from "@material-ui/core";

const sideDrawer = (props) => {
  let drawerCssClass = props.show
    ? [classes.side_drawer, classes.open].join(" ")
    : classes.side_drawer;

  return (
    <nav className={drawerCssClass}>
      <div className={classes.Logo_div}>
        <img src={MediBiro_png} alt="logo" className={classes.Logo} />
      </div>
      {!props.user ? (
        <div style={{ display: "flex", justifyContent: "center", margin: "20px auto" }}>
          <Button
            className={classes.Button}
            onClick={() => {
              props.drawerToggleClickHandler();
              props.hadnleTogleLogin();
            }}
            startIcon={<AccountCircleIcon />}
          >
            Prijavi se
          </Button>
          <span className={classes.Separator}>|</span>
          <NavLink to="/register">
            <Button className={classes.Button} startIcon={<ContactMailIcon />}>
              Registruj se
            </Button>
          </NavLink>
        </div>
      ) : null}
      <ul className={classes.Menu}>
        <li>
          <NavLink onClick={props.drawerToggleClickHandler} exact to="/" activeClassName={classes.ListItemActive}>
            Početna
          </NavLink>
        </li>
        {props.user && (
          <li>
            <NavLink onClick={props.drawerToggleClickHandler} exact to="/region" activeClassName={classes.ListItemActive}>
              Region
            </NavLink>
          </li>
        )}
        <li>
          <NavLink onClick={props.drawerToggleClickHandler} to="/events" activeClassName={classes.ListItemActive}>
            Najava događaja
          </NavLink>
        </li>
        <li>
          <NavLink onClick={props.drawerToggleClickHandler} to="/service" activeClassName={classes.ListItemActive}>
            Usluge
          </NavLink>
        </li>
        <li>
          <NavLink onClick={props.drawerToggleClickHandler} to="/contact" activeClassName={classes.ListItemActive}>
            Kontakt
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

const mapStateToProps = (state) => ({ user: state.user });

const mapDispatchToProps = (dispatch) => ({
  drawerToggleClickHandler: () => dispatch({ type: actionTypes.TOGGLE_DRAWER }),
  hadnleTogleLogin: () => dispatch({ type: actionTypes.TOGGLE_LOGIN }),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(sideDrawer));
